import { Injector } from '@angular/core';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  defaultTimePickerConfigFormModel,
  generateTimePickerForms,
  timePickerFieldParseIntoSettingsFormModel,
  timePickerFieldUpdateFromSettingsFormModel,
} from '../custom-timepicker-field-type.configuration';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { TConfigurationFormModelTypes } from 'src/app/core/models/form-builder-types-configurations.model';

export class CustomTimePickerFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultTimePickerConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...generateTimePickerForms(),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return timePickerFieldParseIntoSettingsFormModel(this.field);
  }
  override updateFieldConfigFromSettingsFormModel(model: any) {
    return timePickerFieldUpdateFromSettingsFormModel(this.field, model);
  }
}
